import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";
import { useAuth } from "./auth";

const SubscriptionContext = createContext({ tier: "free", status: "inactive", features: {} });

export function SubscriptionProvider({ children }) {
  const [sub, setSub] = useState({ tier: "free", status: "inactive", features: {} });
  const { user } = useAuth();

  const refresh = async () => {
    if (!user) return;
    try {
      const r = await api.get("/payments/subscription");
      setSub(r.data);
    } catch { /* ignore */ }
  };

  useEffect(() => { refresh(); }, [user?.id]);

  return <SubscriptionContext.Provider value={{ ...sub, refresh }}>{children}</SubscriptionContext.Provider>;
}

export const useSubscription = () => useContext(SubscriptionContext);
export const hasFeature = (sub, feature) => sub?.features?.[feature] === true;
